(ns frontend.ux-overhaul.table.event
  (:require
   [oops.core :as oops]
   [potpuri.core :as potpuri]
   [re-frame.core :as rf]))

(rf/reg-event-fx
 ::single-select-changed
 (fn [{db :db} [_ selection-path ag-params]]
   (let [grid-api (aget ag-params "api")
         selected-nodes-js (oops/ocall grid-api "getSelectedNodes")
         selected-nodes (js->clj selected-nodes-js :keywordize-keys true)
         selected-node (first selected-nodes)
         selected-node-id (some-> selected-node
                                  (aget "data")
                                  (js->clj {:keywordize-keys true})
                                  :id)]
     (js/console.log "Table selection changed : " selected-node-id)
     {:db (if selected-node-id
            (assoc-in db selection-path selected-node-id)
            (potpuri/dissoc-in db selection-path))})))
